import React, {useEffect} from 'react';
import LoyaltyBadge from "components/loyaltyBadges/loyaltyBadge";
import classnames from 'classnames';
import styles from "./styles";
import {useTheme} from "react-jss";
import {useIsResponsive} from "hooks/useIsResponsive";
import {breakpoints} from "constants/breakpoints";
import UcCarousel from "components/uccarousel";

/**
 *
 * @param {Object} props
 * @returns {Element}
 * @constructor
 */
function LoyaltyBadges(props) {
  const {loyaltyResponse, getLoyaltyList, getRedemptionHistoryCount} = props;
  const theme = useTheme();
  const classes = styles({theme});

  useEffect(() => {
    (async () => {
      await getLoyaltyList();
    })();
  }, []);
  const isFullWidth = useIsResponsive([breakpoints.lg]);

  const onRedeemCompleted = async () => {
    await Promise.all([getLoyaltyList(), getRedemptionHistoryCount()]);
  }
  return (<UcCarousel
    numberOfColumns={3}
    className={classes.loyaltyBadges}
    data={loyaltyResponse?.allotments}
    isFullWidth={isFullWidth}
  >
    <LoyaltyBadge
      allowRedemption={loyaltyResponse?.allowRedemption}
      className={classnames("carousel-tab", {'carousel-tab-mobile': isFullWidth})}
      onRedeemCompleted={onRedeemCompleted}
    />
  </UcCarousel>);
}

export default LoyaltyBadges;